module.exports = __webpack_public_path__ + "static/media/10.04d1641d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/10.png
// module id = 489
// module chunks = 0